import styled from 'styled-components';
import tw from 'twin.macro';

export default styled.div(({ $relative, $absolute, $paddingY, $paddingTop }) => [
  tw`container flow-root mx-auto px-16 break-words`,
  $relative && tw`relative`,
  $absolute && tw`absolute`,
  /* Can't pass a number and use it to construct something of the form tw`pt-${number}`,
     so currently doing it like this. (see https://github.com/ben-rogerson/twin.macro/issues/17 ) */
  $paddingY === 4 && tw`py-4`,
  $paddingY === 8 && tw`py-8`,
  $paddingY === 16 && tw`py-16`,
  $paddingTop && `padding-top: ${$paddingTop}px;`
]);
